import { render, staticRenderFns } from "./displays.vue?vue&type=template&id=3ff64026&"
import script from "./displays.vue?vue&type=script&lang=js&"
export * from "./displays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports